// Relative link rewriting helpers for search results and navigation
// Also removes data-toggle="button" attributes to prevent Bootstrap interference

function processAnchorLinks(anchors: NodeListOf<HTMLAnchorElement>, communityUrl: string) {
  anchors.forEach((link) => {
    const originalHref = link.getAttribute('href');
    if (!originalHref) return;

    // Rewrite relative URLs
    if (originalHref.startsWith('/') && !originalHref.startsWith('//')) {
      const newHref = new URL(originalHref, communityUrl).href;
      if (link.href !== newHref) {
        link.setAttribute('href', newHref);
      }
    }

    // Remove data-toggle="button" to prevent Bootstrap interference
    if (link.getAttribute('data-toggle') === 'button') {
      link.removeAttribute('data-toggle');
    }
  });
}

export function updateRelativeLinks(communityUrl: string, root: ParentNode = document) {
  // Handle shadow root properly - ShadowRoot extends DocumentFragment, not Element
  const scope = (root instanceof Element || root instanceof DocumentFragment) ? root : document;

  // Update Algolia search result links (specific selector)
  const algoliaAnchors = scope.querySelectorAll<HTMLAnchorElement>('.algolia-hit-container a');
  processAnchorLinks(algoliaAnchors, communityUrl);

  // Update relative links in header navigation (specific selector)
  const headerNavigation = scope.querySelector('section.header-navigation');
  if (headerNavigation) {
    const navigationAnchors = headerNavigation.querySelectorAll<HTMLAnchorElement>('a');
    processAnchorLinks(navigationAnchors, communityUrl);
  }

  // Update ALL other anchor links that haven't been processed yet (general catch-all)
  const allAnchors = scope.querySelectorAll<HTMLAnchorElement>('a');
  processAnchorLinks(allAnchors, communityUrl);
}

export function observeRelativeLinks(communityUrl: string, root: Element | Document | DocumentFragment = document) {
  updateRelativeLinks(communityUrl, root);
  // Handle shadow root properly for observation target
  const observeTarget: Node = (root instanceof Element || root instanceof DocumentFragment) ? root : document.body;
  let pending = false;
  const schedule = () => {
    if (pending) return; pending = true;
    setTimeout(() => { pending = false; updateRelativeLinks(communityUrl, root); }, 75);
  };
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        schedule();
        break;
      }
    }
  });
  observer.observe(observeTarget, { childList: true, subtree: true });
}